import { Dialog, IconButton, RichTextArea } from '@myosh/odin-components';
import React, { type Ref, useImperativeHandle, useState } from 'react';

interface AIAnalysisSuggestionContainerProps {
  ref?: Ref<AIAnalysisSuggestionContainerRef>;
}

export interface AIAnalysisSuggestionContainerRef {
  show: (text: string) => void;
}

export const AIAnalysisSuggestionContainer = ({ ref }: AIAnalysisSuggestionContainerProps): React.JSX.Element => {
  const [suggestion, setSuggestion] = useState<string>();
  const [expanded, setExpanded] = useState(false);

  const show = (suggestion: string) => {
    setSuggestion(suggestion);
  };

  useImperativeHandle(ref, () => {
    return { show };
  });

  const handleClickClose = () => {
    setExpanded(false);
    setSuggestion(undefined);
  };

  if (!suggestion) {
    return <></>;
  }

  return (
    <>
      <div
        data-cy="ai-analysis-suggestion-container"
        className="border-gray-1 bg-mono-1 mt-4 mb-4 ml-16 flex h-fit max-h-[200px] w-[75%] flex-col rounded-sm border p-4"
      >
        <div className="flex flex-row items-center justify-between">
          <h3 data-cy="ai-analysis-title" className="font-bold">
            AI Analysis
          </h3>
          <div className="flex flex-row items-center gap-2">
            <IconButton
              data-cy="ai-analysis-expand-button"
              icon="Fullscreen"
              tooltip="Expand AI Analysis"
              onClick={() => setExpanded(true)}
            />
            <IconButton
              data-cy="ai-analysis-close-button"
              icon="X"
              tooltip="Close AI Analysis"
              onClick={handleClickClose}
            />
          </div>
        </div>

        <hr className="border-gray-4 mt-4 mb-4" />

        <div data-cy="ai-analysis-content-wrapper" className="min-h-0 flex-1 overflow-y-auto">
          <RichTextArea readOnly content={suggestion} className="whitespace-pre-line" />
        </div>
      </div>

      <Dialog
        data-cy="ai-analysis-expanded-dialog"
        header="AI Analysis"
        visible={expanded}
        onClose={() => setExpanded(false)}
        className="w-[800px] max-w-[calc(100svw-2rem)]"
      >
        <RichTextArea readOnly content={suggestion} className="whitespace-pre-line" />
      </Dialog>
    </>
  );
};

export default AIAnalysisSuggestionContainer;
